/*
 * @Description:
 * @Autor: txp
 * @Date: 2021-05-07 14:11:03
 */
import Vue from 'vue'
import Router from 'vue-router'
import { staticRouters } from './routers'
import Nprogress from 'nprogress'
import 'nprogress/nprogress.css'
import { MessageBox } from 'element-ui'
Vue.use(Router)

export const router = new Router({
  mode: 'history',
  linkActiveClass: 'active',
  linkExactActiveClass: 'active',
  routes: staticRouters,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})

/**
 * 路由前置函数
 */
router.beforeEach((to, from, next) => {
  Nprogress.start()
  const token = localStorage.getItem('TokenKey')
  const path = to.path

  if (token) {
    if (path === '/login') {
      next('/home')
    } else if (from.path == '/home/shopsesttle') {
      if (to.query.type) {
        next()
        return
      }
      MessageBox.confirm('退出后将无法保存订单信息', '是否退出订单结算界面', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          next()
        })
        .catch(() => {})
    } else {
      next()
    }
  } else {
    if (path !== '/login') {
      next('/login')
    } else {
      next()
    }
  }
  // if (to.path == '/login' || to.path == '/') {
  //   next()
  // } else if (from.path == '/home/shopsesttle') {
  //   if (to.query.type) {
  //     next()
  //     return
  //   }
  //   MessageBox.confirm('退出后将无法保存订单信息', '是否退出订单结算界面', {
  //     confirmButtonText: '确定',
  //     cancelButtonText: '取消',
  //     type: 'warning'
  //   })
  //     .then(() => {
  //       next()
  //     })
  //     .catch(() => {})
  // } else {
  //   if (Storage.l.get('userName')) {
  //     next()
  //   } else {
  //     next('/login')
  //      Nprogress.done()
  //   }
  // }
})
/**
 * 路由后置函数
 */
router.afterEach(() => {
  Nprogress.done()
})
